<template>
  <!--内容类别管理-->
  <div id="contentList">
<!--    <div class="allSearch">-->
<!--      <div class="newSearch d_flex">-->
<!--        <div style="width: auto;white-space: normal;">-->
<!--          <p>-->
<!--            <input @keyup.enter="getList(1)" class="allInput" type="number" placeholder="类别ID" v-model="postData.id">-->
<!--          </p>-->
<!--          <p>-->
<!--            <input @keyup.enter="getList(1)" class="allInput" type="text" placeholder="类别名称" v-model="postData.typeName">-->
<!--          </p>-->
<!--          <p v-if="onSearch">-->
<!--            <input @keyup.enter="getList(1)" class="allInput" type="text" placeholder="Content Editor" v-model="postData.editor">-->
<!--          </p>-->
<!--          <p v-if="onSearch">-->
<!--            <input @keyup.enter="getList(1)" class="allInput" type="text" placeholder="Content Owner" v-model="postData.owner">-->
<!--          </p>-->
<!--          <p v-if="onSearch">-->
<!--            <cander v-model="postData.beginTime" :className="'allInput'" placeholderName="创建时间"  class="d_i" style="vertical-align: middle"></cander>-->
<!--          </p>-->
<!--          <p>-->
<!--            <abbr class="d_i">-->
<!--              <allSelect :chooseData="allStatus" :needReturn="'id'" :placeholder="'状态'" :matchValue="'name'" :showValue="'{{name}}'" v-model="postData.status">-->
<!--              </allSelect>-->
<!--            </abbr>-->
<!--          </p>-->
<!--        </div>-->
<!--        <div style="width: auto;">-->
<!--          <span class="colorCH c_p" style="text-decoration: underline" @click="tewoSearch()">{{onSearch ? '快速搜索':'高级搜索'}}</span>-->
<!--          <button class="redButton" @click="selectCont">-->
<!--            <i class="icon iconfont iconsousuo"></i>-->
<!--            搜索-->
<!--          </button>-->
<!--          <button class="cancelButtonTwo" @click="selectEmpty">-->
<!--            清空-->
<!--          </button>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <div class="allTablePlace">
      <div class="t_r"><button class="redButtonTwo m_b_10" @click="editToUrl" >新建</button></div>
      <div>
        <table cellspacing="0" class="allTable">
          <thead>
          <tr>
            <th>产品组名称</th>
            <th>分类名称</th>
            <th>创建人</th>
            <th>创建时间</th>
            <th>操作</th>
          </tr>
          </thead>
          <tbody>
          <tr :key="index" v-for="(item, index) in myList">
            <td>{{item.productName}}</td>
            <td>{{item.name}}</td>
            <td>{{item.createName}}</td>
            <td>{{item.creationTime}}</td>
            <td class="colorBlue"><div class="icon more iconfont icongengduo moreOperations">
              <ul>
                <li @click="editContentType(item)">编辑</li>
                <li @click="deleteType(item)" >删除</li>
              </ul>
            </div>
<!--              <span  style="cursor: pointer;text-decoration:underline #408DEB;">编辑</span>-->
<!--              <span  style="cursor: pointer;text-decoration:underline #408DEB;">删除</span>-->
            </td>
          </tr>
          </tbody>
        </table>
      </div>
<!--      <page v-if="totalPage !== 0" :totalCount="totalCount" v-on:on-getList="getList($event)" :totalPage="totalPage" :page="page" :explain="0"></page>-->
    </div>
    <model v-if="newModel" :buttonType="0" :title="'分类'" :minWidth="'500px'" v-on:on-cancel="newModel = false" v-on:on-confirm="confirModel()">
      <div style="height: 300px">
        <ul class="allUL">
          <li v-if="isAdmin === 'true'"><span>请选择产品组</span> <abbr>
            <allSelect :width="300" style="display: inline-block" :chooseData="allProduct" :needReturn="'id'" :placeholder="'请选择'" :matchValue="'name'" :showValue="'{{name}}'" v-model="cateModel.productId">
            </allSelect>
          </abbr></li>
          <li v-else><span>请选择产品组</span> <abbr>
            <allSelect :width="300" style="display: inline-block" :chooseData="productList" :needReturn="'id'" :placeholder="'请选择'" :matchValue="'name'" :showValue="'{{name}}'" v-model="cateModel.productId">
            </allSelect>
          </abbr></li>
          <li><span>分类名称</span> <abbr>
            <input style="width: 290px" class="allInput" v-model="cateModel.name" type="text">
          </abbr></li>
        </ul>
      </div>
    </model>
  </div>
</template>

<script>
export default {
  name: 'contentList',
  data () {
    return {
      newModel: false,
      nowApp: JSON.parse(window.sessionStorage.getItem('nowApp')),
      productList: JSON.parse(window.localStorage.getItem('productList')),
      isSystemAdmin: window.sessionStorage.getItem('isSystemAdmin'),
      isAdmin: window.localStorage.getItem('isAdmin'),
      onSearch: false,
      showModel: false,
      tabSwitch: 1,
      totalPage: 1,
      totalCount: 0,
      page: 1,
      cateModel: {
        id: 0,
        name: '',
        productId: 0,
        productName: ''
      },
      allProduct: [],
      postData: {
        id: '',
        status: -1,
        typeName: '',
        owner: '',
        editor: '',
        Status: '',
        beginTime: '',
        pageIndex: 1,
        pageSize: this.$commonJs.commonPageSize
      },
      myList: [],
      allStatus: [
        {
          id: -1,
          name: '全部'
        },
        {
          id: 1,
          name: '有效'
        },
        {
          id: 0,
          name: '无效'
        }
      ]
    }
  },
  created () {
    this.getList(1)
    this.getAllProDuct()
  },
  methods: {
    deleteType (item) {
      this.$commonJs.doubleComfirm({
        content: '确定删除此分类？',
        successFun: msg => {
          this.$axiox.del('/api/product/CateGory/' + item.id).then(msg => {
            this.$commonJs.alertTips({
              type: 'success',
              title: '成功',
              content: '删除成功',
              stayTime: 5
            })
            this.getList(1)
          })
        },
        errorFun: msg => {
        }
      })
    },
    getAllProDuct () {
      this.$axiox.get('/api/product/query?PageIndex=1&PageSize=9999').then(p => {
        this.allProduct = p
      })
    },
    // 切换搜索条件
    tewoSearch () {
      this.onSearch = !this.onSearch
    },
    // 新建
    editToUrl () {
      this.newModel = true
      this.cateModel = {
        id: 0,
        name: '',
        productId: 0,
        productName: ''
      }
      // this.$router.push({
      //   name: 'editCategoryList',
      //   params: {
      //     id: 0
      //   }
      // })
    },
    getList (pageIndex) {
      this.postData.pageIndex = pageIndex
      let url = this.$commonJs.returnQuery('/api/product/cateGory/query', {})
      this.$axiox.get(url).then(msg => {
        this.page = pageIndex
        this.myList = msg
        window.localStorage.setItem('canEditList', JSON.stringify(this.myList))
        // this.totalPage = Math.ceil(msg.result.totalCount / this.postData.pageSize)
        // this.totalCount = msg.result.totalCount
      })
    },
    selectCont () {
      this.getList(1)
    },
    confirModel () {
      if (!this.cateModel.name) {
        this.$commonJs.alertTips({
          type: 'error',
          title: '失败',
          content: '请输入分类名称',
          stayTime: 5
        })
        return
      }
      if (!this.cateModel.productId) {
        this.$commonJs.alertTips({
          type: 'error',
          title: '失败',
          content: '请选择产品',
          stayTime: 5
        })
        return
      }
      this.cateModel.productName = this.allProduct.find(p => {
        return p.id === this.cateModel.productId
      }).name
      if (this.cateModel.id === 0) {
        this.$axiox.post('/api/product/Category/Add', this.cateModel).then(p => {
          this.$commonJs.alertTips({
            type: 'success',
            title: '成功',
            content: '新建成功',
            stayTime: 5
          })
          this.getList(1)
          this.newModel = false
        })
      } else {
        this.$axiox.post('/api/product/Category/Update', this.cateModel).then(p => {
          this.$commonJs.alertTips({
            type: 'success',
            title: '成功',
            content: '编辑成功',
            stayTime: 5
          })
          this.getList(1)
          this.newModel = false
        })
      }
    },
    cancelModel () {
      this.showModel = false
    },
    editContentType (item) {
      this.cateModel = {
        id: item.id,
        name: item.name,
        productId: item.productId,
        productName: item.productName
      }
      this.newModel = true
    },
    selectEmpty () {
      this.postData.id = ''
      this.postData.typeName = ''
      this.postData.editor = ''
      this.postData.owner = ''
      this.postData.beginTime = ''
      this.postData.status = '-1'
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/contentManger/categoryNewList.vue